import React, { Component } from 'react';
import { Card, Badge, ListGroup } from 'react-bootstrap';

const locale = 'en-US';
const dateFormatOptions = { month: 'short' , day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true };

export class Elders extends Component {
    constructor(props) {
        super(props);
        this.state = {
          error: null,
          isLoaded: false,
          items: []
        };
      }

    componentDidMount() {
        fetch("/data/elders.json")
            .then(res => res.json())
            .then(
            (result) => {
                this.setState({
                isLoaded: true,
                items: result.documents.filter(item => Date.parse(item.date) >= new Date())
                });
            },
            (error) => {
                this.setState({
                isLoaded: true,
                error
                });
            }
        )
    }

    render() {
        const { error, isLoaded, items } = this.state;
        if (error) {
        return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
        return <div>Loading...</div>;
        } else {
        return <div>
            <h3>Elder's Quorum</h3>
            <br />
            <Card>

                <Card.Title>
                    Sunday Meetings @ 1:10pm - 2:00pm
                </Card.Title>
                <Card.Body>
                    <h4>
                        Meeting every 1st and 3rd Sunday of each month.
                    </h4>            
                </Card.Body>              
            </Card>
            <Card>
                <Card.Title>
                  Announcements
                </Card.Title>
                <Card.Body>
                    <ListGroup>
                    {items.length > 0 ? items.map(item => (
                    <EldersQuorumItem
                        title={item.title}
                        date={item.date}
                        link={item.link}
                        body={item.body}
                        image={item.image}/>
                    )): <p>{"No Announcements Right Now!"}</p>}
                    </ListGroup>         
                </Card.Body>              
          </Card>
        </div>;
        }
    }
  }

export class ListGroupLinkItem extends Component {
    render() {
    return <ListGroup.Item>
        <a href={this.props.link}>{this.props.text}</a>
        </ListGroup.Item>
    }
}

export class EldersQuorumItem extends Component {
render() {
    let image = (this.props.image !== '') ? <img href={this.props.image} alt={this.props.title} /> : null;
    if (this.props.link === '')
    {
        return <ListGroup.Item>
            <h5>
                <DateBadge date={this.props.date} displayDate={this.props.displayDate} />
            {this.props.title}
            </h5>
            <p>{this.props.body}</p>
            {image}
        </ListGroup.Item>
    }
    return <ListGroup.Item>
    <a href={this.props.link} alt={this.props.title} target="_blank" rel="noopener noreferrer">
            <h5>
            {this.props.title}
            </h5>
            <p>{this.props.body}</p>
            {image}
        </a>  
    </ListGroup.Item>;
}
}

class DateBadge extends Component {
render() {
    const date = Date.parse(this.props.date)
    if (this.props.displayDate)
    {
    return <span><Badge>{
        this.props.displayDate
    }</Badge>&nbsp;</span>
    }
    if (date)
    {
    return <span><Badge>{
        new Intl.DateTimeFormat(locale, dateFormatOptions).format(date)
    }</Badge>&nbsp;</span>
    }
    return null;
}
}

  export default Elders;